// components/LatestUsersList.jsx
import React from 'react';

const sampleUsers = [
  { id: 1, firstName: 'John', lastName: 'Doe', email: 'john.doe@example.com', dateRegistered: '2024-01-15' },
  { id: 2, firstName: 'Jane', lastName: 'Smith', email: 'jane.smith@example.com', dateRegistered: '2024-01-14' },
  { id: 3, firstName: 'Michael', lastName: 'Johnson', email: 'michael.j@example.com', dateRegistered: '2024-01-13' },
  { id: 4, firstName: 'Emily', lastName: 'Brown', email: 'emily.brown@example.com', dateRegistered: '2024-01-12' },
  { id: 5, firstName: 'David', lastName: 'Wilson', email: 'david.wilson@example.com', dateRegistered: '2024-01-11' }
];

const LatestUsersList = () => {
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div className="dbmm-latest-users-container">
            <h3 className="dbmm-section-title">Latest Users</h3>
            <div className="dbmm-users-table-wrapper">
                <table className="dbmm-users-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Date Registered</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sampleUsers.map(user => (
                            <tr key={user.id}>
                                <td>{user.firstName} {user.lastName}</td>
                                <td>{user.email}</td>
                                <td>{formatDate(user.dateRegistered)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LatestUsersList;